<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row>
            <ion-col size="12" size-sm="10" offset-sm="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
                <div class="padding">

                    <h1 class="text-center">Kontakt</h1>
                    <div v-if="loading" class="pd-20 text-center" style="width: 100%"><span class="loader red"></span></div>
                    <div class="rte" v-html="rte"></div>

                    <!--contact form-->
                    <form class="form form-user-update" @submit.prevent="postContact">
                        <div class="form-group">
                            <label>Adres e-mail:</label>
                            <input v-model="email"
                                   :class="{'input-error' : errors.email }"
                                   type="text"
                                   placeholder="Podaj e-mail"/>
                            <p class="text-gray-light text-small">Na podany adres e-mail otrzymasz od nas odpowiedź.</p>
                            <p class="error" v-if="errors.email">
                                <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                <span v-text="errors.email"></span>
                            </p>
                        </div>
                        <div class="form-group">
                            <label>Kategoria:</label>
                            <div v-if="loading_categories" class="pd-20 text-center" style="width: 100%"><span class="loader red"></span></div>
                            <div v-else class="select-wrapper">
                                <span v-if="category === ''" class="select-placeholder">Wybierz kategorię</span>
                                <select v-model="category">
                                    <option v-for="(item,key) in categoriesCollection"
                                            :key="key"
                                            :value="item">{{ item }}
                                    </option>
                                </select>
                            </div>
                            <p class="error" v-if="errors.category">
                                <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                <span v-text="errors.category"></span>
                            </p>
                        </div>
                        <div class="form-group">
                            <label>Treść wiadomości:</label>
                            <textarea type="textarea"
                                      v-model="message"
                                      rows="8"
                                      :class="{'input-error' : errors.email }">
                            </textarea>
                            <p class="error" v-if="errors.message">
                                <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                <span v-text="errors.message"></span>
                            </p>
                        </div>
                        <div class="form-group">
                            <label>Załącznik:</label>
                            <input type="file"
                                   id="fileInput"
                                   ref="file"
                                   placeholder="Dodaj"
                                   :accept="file_accept_type"
                                   v-on:change="handleFileUpload($event)">
                            <p class="text-gray-light text-small">Dołącz plik Excel, Word, obraz lub PDF Maksymalna wielkość 5 MB.</p>
                            <p class="error" v-if="errors.file">
                                <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                <span v-text="errors.file"></span>
                            </p>
                        </div>
                        <notification v-if="notification" :type="notificationType" :text="notificationText"></notification>
                        <button class="btn btn-primary" type="submit" :disabled="disabledButton || loading_form">
                            <span v-if="loading_form"><span class="loader"></span></span>
                            <span v-else>Wyślij wiadomość</span>
                        </button>
                    </form>

                </div>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
    import api from '@/services/Api';
    import { mapGetters } from 'vuex'
    import { mapFields } from 'vuex-map-fields';
    import notification from '../../components/Notification'

    export default {
        name: 'ContactIndex',
        components: { notification },
        data() {
            return {
                loading: false,
                loading_categories: false,
                loading_form: false,
                errors: {},
                // form
                category: '',
                message: '',
                file: null,
                // data from api
                categoriesCollection: [],
                rte: '',
                // accepted file types
                file_accept_type: [
                    "image/png",
                    "image/jpg",
                    "image/jpeg",
                    "application/pdf",
                    "application/vnd.oasis.opendocument.text",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "application/vnd.oasis.opendocument.spreadsheet",
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
                ],
                // notification
                notification: false,
                notificationType: 'success',
                notificationText: '',
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapFields({
                email: 'profile.email',
            }),

            disabledButton(){
                return (this.email === '' || this.message === '') ? true : false;
            }
        },
        mounted() {
            this.getContact()
        },
        methods: {
            getContact() {
                this.loading = true;
                api.get('/api/v1/configuration/contact_text').then(response => {
                    this.loading = false;
                    this.rte = response.data.data.html
                    // get categories after contact text
                    this.getContactCategories()
                })
            },
            getContactCategories(){
                this.loading_categories = true;
                let userType = this.getProfile.userType;
                api.get('/api/v1/contact-categories/'+ userType).then(response => {
                    this.loading_categories = false;
                    this.categoriesCollection = response.data.data[0] // stupid api
                })
            },
            postContact(){
                console.log('postContact')
                this.loading_form = true;
                // prepare form data
                let formData = new FormData();
                // append new form fields
                formData.append('category', this.category);
                formData.append('message', this.message);
                // append user
                Object.keys(this.getProfile).forEach(key => formData.append(key, this.getProfile[key]));
                // append file
                if(this.file) formData.append('file', this.file);
                // prepare additional headers
                let headers = { 'Content-Type': 'multipart/form-data' };
                // post form
                api.post('/api/v1/contact',formData,{ headers: headers }).then(response => {
                    this.loading_form = false;
                    if (response.status === 200) {
                        // notification
                        this.notification = true
                        this.notificationType = 'success'
                        this.notificationText = response.data.message
                        // toast
                        this.$ionic.toastController
                            .create({
                                message: 'Wysłano poprawnie.',
                                duration: 2000,
                                mode: 'md'
                            })
                            .then(a => a.present());
                    }
                }).catch(err => {
                    this.loading_form = false;
                    if (err.response && err.response.data)
                        this.errors = err.response.data.errors ? err.response.data.errors : [];
                    if (err.response.status === 400) {
                        // notification
                        this.notification = true
                        this.notificationType = 'error'
                        this.notificationText = err.response.data.message
                    }
                    if (err.response.status === 500) {
                        // toast
                        this.$ionic.toastController
                            .create({
                                message: 'Błąd serwera.',
                                duration: 2000,
                                mode: 'md'
                            })
                            .then(a => a.present());
                    }
                })
            },
            handleFileUpload(e){
                if(this.$refs.file.files[0] === undefined) return;

                // check file type
                console.log(this.$refs.file.files[0].type);
                if(this.file_accept_type.indexOf(this.$refs.file.files[0].type)  === -1 ){
                    this.errors.file = "Niedopuszczalny format pliku!";
                    this.$refs.file.value = null; // clear input
                    this.$forceUpdate();
                    return;
                }

                // check file size
                if(this.$refs.file.files[0].size > (5242880) ){
                    this.errors.file = "Plik jest za duzy! Max 5MB";
                    this.$refs.file.value = null; // clear input
                    this.$forceUpdate();
                    return;
                }

                // file is correct
                this.errors = {} // clear errors
                this.$forceUpdate();
                this.file = this.$refs.file.files[0];
            }
        }
    }
</script>